import { AdditionServicesOptionsState } from '@pages/AdditionalServices/containers/additionServicesOptionsContext';
import servicesFilter from '@pages/AdditionalServices/containers/services/servicesFilter';
import servicesOrder from '@pages/AdditionalServices/containers/services/servicesOrder';
import {
  AServiceCache,
  AServicePropertyCache,
  AServicePropertyFilterAndOrder,
  AdditionServicesState,
} from '@pages/AdditionalServices/containers/types';

import { ServiceData, SetUpServiceData } from '../../../basket/types';
import { serviceRestoreStateGeneratorProcessor } from '../types';

/**
 * FilterResultProcessor формирует порядок и видимость для каждого фильтра варианта
 */
export class FilterResultProcessor implements serviceRestoreStateGeneratorProcessor {
  /**
   * restore restore выполняет восстановление стейтов. Возвращает все стейты.
   * @param _
   * @param __
   * @param additionalServiceState
   * @param optionsState
   * @param serviceCacheState
   * @param servicePropertyCacheState
   * @param servicePropertyFilterAndOrderState
   */
  async restore(
    _: SetUpServiceData,
    __: (SetUpServiceData | ServiceData)[],
    additionalServiceState: AdditionServicesState,
    optionsState: AdditionServicesOptionsState,
    serviceCacheState: AServiceCache,
    servicePropertyCacheState: AServicePropertyCache,
    servicePropertyFilterAndOrderState: AServicePropertyFilterAndOrder
  ) {
    const newFilterData = { ...servicePropertyFilterAndOrderState };

    Object.keys(servicePropertyFilterAndOrderState.Variants).map((variantID) => {
      newFilterData.Variants[variantID] = {
        ...servicePropertyFilterAndOrderState.Variants[variantID],
        IsSortChanged: false,
        ServiceVisibility: {},
        ServicePriority: {},
      };
    });

    // Вычисляем видимость услуг для всех вариантов
    Object.keys(additionalServiceState.VariantServices).map((variantID) => {
      additionalServiceState.VariantServices[variantID].map((s) => {
        newFilterData.Variants[variantID].ServiceVisibility[s.id] = false;
      });

      // Фильтруем услуги, которые необходимо показывать и помечаем для показа
      servicesFilter()
        .Filter(
          additionalServiceState.VariantServices[variantID],
          additionalServiceState.VariantsCalculationResult[variantID],
          servicePropertyFilterAndOrderState.Variants[variantID]
        )
        .map((service) => {
          newFilterData.Variants[variantID].ServiceVisibility[service.id] = true;
        });
    });

    // Вычисляем сортировку услуг для всех вариантов
    Object.keys(additionalServiceState.VariantServices).map((variantID) => {
      additionalServiceState.VariantServices[variantID]
        .sort(
          servicesOrder().Order(
            servicePropertyFilterAndOrderState.Variants[variantID],
            additionalServiceState.VariantsCalculationResult[variantID]
          )
        )
        .map((service, i) => {
          newFilterData.Variants[variantID].ServicePriority[service.id] = i;
        });
    });

    return {
      isValid: true,
      additionalServiceState,
      optionsState,
      serviceCacheState,
      servicePropertyCacheState,
      servicePropertyFilterAndOrderState: newFilterData,
    };
  }
}
